<div class="flex-container center-align">
  <shared-ui-flow-icon
    *ngIf="highPriorityTooltip"
    [matTooltip]="highPriorityTooltip | translate"
    class="margin-right-8"
    icon="workflow-high-priority.svg"
  ></shared-ui-flow-icon>
  <shared-ui-flow-icon
    *ngIf="longRunningTooltip"
    [matTooltip]="longRunningTooltip"
    class="margin-right-8"
    icon="workflow-long-running.svg"
  ></shared-ui-flow-icon>
  <span class="mat-caption long-running-tooltip">{{longRunningTooltip}}</span>
</div>
